import React, { useEffect } from "react";
import { BeatLoader } from "react-spinners";

const Table = ({ className, header, children, isLoading }) => {
  return (
    <div className="overflow-scroll height-300">
      <table className={className}>
        <tbody>
          <tr>
            {header?.map((ele, i) => (
              <th key={i}>{ele}</th>
            ))}
          </tr>
          {isLoading && (
            <tr>
              <td colSpan="100%">
                <div>
                  <BeatLoader loading={isLoading} />
                </div>
              </td>
            </tr>
          )}
          {!isLoading && children}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
